import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs/operators';
import * as errorHandlingActions from './error-handling.actions';
import {logErrorIfInDev} from './log-error.operator';
import {SeFeToastService} from 'se-fe-toast';

@Injectable()
export class ErrorHandlingEffects {
  uncaughtError$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(errorHandlingActions.uncaughtError, errorHandlingActions.unrecoverableError),
        tap(() => {
          this.toast.critical('An error occurred.');
        })
      );
    },
    {dispatch: false}
  );

  logError$ = createEffect(
    () => {
      return this.actions$.pipe(ofType(errorHandlingActions.logError), logErrorIfInDev());
    },
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private toast: SeFeToastService
  ) {}
}
